import styled from 'styled-components'

export const AddressComponentWrapper = styled.div`
	.ppneo-autocomplete-textarea__container {
		margin-bottom: 0;
	}

	.ppneo-autocomplete-textarea__container--error {
		textarea.ant-input.ant-select-search__field,
		&:hover textarea.ant-input.ant-select-search__field {
			border: 1px solid #ff0066;
		}
	}
`
